import { ChatBubbleOutlineOutlined, ExpandMore } from '@mui/icons-material';
import { Button, Stack } from '@mui/material';
import { PageHeaderStatic, WidgetIcon, useButtonMenu } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';
import { Union } from 'ts-toolbelt';

import { SvbrgIntakeStatus } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';

import { ActionsMenu } from './ActionsMenu/ActionsMenu';
import { PageAction } from './ActionsMenu/components/Actions';
import { IntakeDetailPageTitle } from './IntakeDetailPageTitle';

const getPageActionByStatus = (status?: Union.Nullable<SvbrgIntakeStatus>) => {
  switch (status) {
    case SvbrgIntakeStatus.DRAFT:
      return [PageAction.DISCARD, PageAction.SAVE_DRAFT];
    case SvbrgIntakeStatus.CANCELLED:
      return [PageAction.RETURN_TO_LIST, PageAction.DISCARD];
    default:
      return [PageAction.RETURN_TO_LIST, PageAction.CANCEL];
  }
};

type IntakeDetailPageHeaderProps = {
  id: string;
  status?: Union.Nullable<SvbrgIntakeStatus>;
};

export const IntakeDetailPageHeader = ({ id, status }: IntakeDetailPageHeaderProps) => {
  const { menuProps, buttonProps } = useButtonMenu();
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeDetail' });
  const actions = getPageActionByStatus(status);
  return (
    <PageHeaderStatic
      title={<IntakeDetailPageTitle />}
      maxWidth={false}
      icon={<WidgetIcon icon={<ChatBubbleOutlineOutlined fontSize="small" />} />}
      right={
        <Stack
          spacing={3}
          direction="row"
          sx={{
            overflow: 'hidden',
            alignItems: 'center',
          }}
        >
          <>
            <Button
              variant="outlined"
              endIcon={<ExpandMore fontSize="small" />}
              {...buttonProps}
              data-intercom-target="IntakeDetail/Actions"
            >
              {t('actionsMenuButton')}
            </Button>
            <ActionsMenu id={id} {...menuProps} actions={actions} />
          </>
        </Stack>
      }
    />
  );
};
